<!-- 历任基金经理列表 -->
<template>
  <div v-if="!$isEmpty(dataList)" class="fund-manager-list">
    <!-- 标题 -->
    <div class="title row">
      <div>基金经理</div>
      <div :style="{flex: 1, textAlign: 'right'}" @click="goManagerList">历任基金经理</div>
      <img :src="RIGHT_ARROW" class="arrow" @click="$goFundApp"/>
    </div>
    <!-- 列表 -->
    <div v-for="(item, index) in dataList" :key="index"
      class="manager-item"
      @click="$goFundApp">
      <div class="intro row">
        <img :src="item.avatar" class="avatar" />
        <!-- 基础信息 -->
        <div class="basic-info">
          <div class="name row">
            <div>{{item.name}}</div>
            <img v-if="item.isGoldBullManager" :src="GOLD_BULL" class="gold-bull"/>
          </div>
          <div class="serve-days">{{`从业${item.workDays} 年化回报${item.yearSyl}`}}</div>
        </div>
      </div>
      <!-- 任期 -->
      <div class="work-days row">
        <div class="work-days-info">
          <div>本基金当前任期</div>
          <div class="value">{{`${item.serviceDate}至今 ${item.serviceDays}`}}</div>
        </div>
        <div class="syl">
          <div>任职回报</div>
          <div :style="{color: getRateColor(item.serviceSyl), textAlign:'right'}" class="value"
            >{{item.serviceSyl}}</div>
        </div>
      </div>
      <!-- 投资理念 -->
      <div v-if="!$isEmpty(item.investIdeas)" class="invest-idea">
        <p><img :src="IDEA_IMG" class="idea-img"/><span>{{item.investIdeas}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {

  name: 'fund-manager-list',

  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
      GOLD_BULL: 'https://j5.dfcfw.com/sc/image/202110/20211015002345.png',
      IDEA_IMG: 'https://j5.dfcfw.com/sc/image/202110/20211012073040.png',
    };
  },

  computed: {
    dataList() {
      return this.detailInfo?.currentFundManager || [];
    },
  },

  methods: {
    getRateColor: tool.getRateColor,

    goManagerList() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.lrjjjl.click', '');
      this.$goFundApp();
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fund-manager-list {
  width: 100%;
  padding-top: 32px;
  .arrow {
    width: 32px;
    height: 32px;
    margin-left: 8px;
  }
  .title {
    justify-content: left;
    font-size: 28px;
    color: #666666;
  }
  .manager-item {
    width: 100%;
    padding: 32px 0;
    .intro {
      width: 100%;
      .avatar {
        width: 120px;
        height: 120px;
        border-radius: 60px;
        object-fit: cover;
      }
      .basic-info {
        margin-left: 24px;
        .name {
          font-size: 32px;
          color: #000000;
          line-height: 32px;
          font-weight: 500;
          .gold-bull {
            width: 193px;
            height: 32px;
            margin-left: 12px;
          }
        }
        .serve-days {
          font-size: 28px;
          color: #666666;
          line-height: 28px;
          margin-top: 24px;
        }
      }
    }
    .work-days {
      font-size: 28px;
      color: #999999;
      line-height: 28px;
      justify-content: space-between;
      margin-top: 32px;
      .value {
        font-family: DINAlternate-Bold;
        font-size: 30px;
        color: #000000;
        margin-top: 16px;
      }
    }
    .invest-idea {
      margin-top: 30px;
      p {
        font-size: 30px;
        color: #000000;
        line-height: 50px;
        margin: 0;
      }
      .idea-img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
